import { render, staticRenderFns } from "./TongzhiEdit.vue?vue&type=template&id=3b1ec066"
import script from "./TongzhiEdit.vue?vue&type=script&lang=js"
export * from "./TongzhiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports